/**
 * 图片 URL 处理（与小程序一致，同一配置双端使用）
 */
const IMAGE_BASE = 'https://wvxvb.cn/images/'

export function getImageUrl(imageName) {
  if (!imageName) return ''
  if (/^https?:\/\//.test(imageName)) return imageName
  const cleanName = (imageName + '').replace(/^\/static\/images\//, '')
  return IMAGE_BASE + cleanName
}
